import React, { FC, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import urls from 'constants/urls';
import useCompany from 'hooks/api/useCompany';
import pencilSvg from 'assets/img/newPencil.svg';
import delSvg from 'assets/img/newDelete.svg';
import reloadSvg from 'assets/img/reload.svg';
import ViewGeneralActions from 'components/common/ViewGeneralActions';
import ConfirmationDeleteModal from 'components/common/ConfirmationDeleteModal';
import { deleteCompanyById } from 'api/company';
import { Button, Modal, notification } from '@gamesb42/ui-kit';
import { deleteUser, resetPassword } from 'api/users';
import baseRequest from 'queries/baseRequest';
import Flex from 'components/Flex';

type PropsT = {
  name: string;
  role: string;
  email: string;
};

const ActionButtonCard: FC<PropsT> = ({ name, role, email }) => {
  const history = useHistory();
  //@ts-ignore
  const { userId } = useParams();

  const restoreUser = async (userId: string) => {
    try {
      await baseRequest({
        path: `${process.env.REACT_APP_SCA_URL}/v1/users/${userId}/restore`,
        options: {
          method: 'PATCH',
        },
      });

      window.dispatchEvent(new CustomEvent('updateParent'));
    } catch (error) {
      console.error('Ошибка при восстановлении пользователя:', error);
    } finally {
      history.push(`/admins?isArchive=false`);
    }
  };

  const getButtonList = () => {
    const buttonList = [
      {
        image: pencilSvg,
        title: 'Edit User',
        style: { color: '#838998' },
        onClick: () => history.push(`/admins/edit-admin/${userId}`),
      },
      {
        image: reloadSvg,
        title: 'Reset Password',
        style: { color: '#838998' },
        onClick: () =>
          Modal.warning({
            title: 'Reset Password',
            width: 598,
            okButtonProps: {
              style: { background: '#EC3E72', border: 'none' },
            },
            okText: 'Reset Password',
            content: `Are you sure you want to reset the password for user ${name}? This action cannot be undone`,
            onOk: () =>
              resetPassword({ email })
                .then(() => {
                  notification.success({
                    theme: 'dark',
                    message: 'Password Reset Email Sent',
                    description: `A password reset email has been sent to ${email}`,
                    placement: 'bottomLeft',
                  });
                })
                .catch((error) => {
                  console.error('Reset password error:', error);
                  notification.error({
                    theme: 'dark',
                    message: 'Failed to Reset Password',
                    description: 'Failed to send password reset email. Please try again.',
                    placement: 'bottomLeft',
                  });
                }),
            onCancel: () => {},
          }),
      },
      {
        image: delSvg,
        title: 'Delete User',
        style: { color: '#EC3E72' },
        onClick: () =>
          Modal.warning({
            title: 'Delete Admin',
            okButtonProps: {
              style: { background: '#EC3E72', border: 'none' },
            },
            okText: 'Delete',
            content: `Are you shure you want to delete ${role} ${name}?`,
            onOk: () =>
              deleteUser(userId)
                .then(() => {
                  notification.warning({
                    theme: 'dark',
                    message: (
                      <Flex gap="10px" direction="column">
                        <div>{`${role} ${name} was deleted`}</div>
                        <Button style={{ alignSelf: 'flex-end' }} onClick={() => restoreUser(userId)}>
                          Restore
                        </Button>
                      </Flex>
                    ),
                    placement: 'bottomLeft',
                  });
                })
                .catch(() => {})
                .finally(() => {
                  history.push(urls.getAdmins());
                }),
            onCancel: () => {},
          }),
      },
    ];

    return buttonList;
  };

  return (
    <div>
      <ViewGeneralActions buttonList={getButtonList()} />
    </div>
  );
};

export default ActionButtonCard;
